import { Eye, X } from "lucide-react";
import { useCopilotPageContext } from "@/features/copilot/components/copilot-page-context-provider";

/// Sits inside the composer, next to Send, because it describes what the next message carries.
export function CopilotPageChip() {
  const { context, dismissed, dismiss } = useCopilotPageContext();
  if (!context || dismissed) return null;
  const { label } = context.hint;

  return (
    <div
      className="flex h-7 min-w-0 items-center gap-1.5 rounded-full bg-muted pr-0.5 pl-2.5 text-xs text-text-secondary"
      title={`Hand can see: ${label}`}
    >
      <Eye aria-hidden="true" className="size-3.5 shrink-0" />
      <span className="sr-only">Hand can see </span>
      <span className="min-w-0 truncate">{label}</span>
      <button
        type="button"
        aria-label={`Stop sharing ${label} as context`}
        onClick={dismiss}
        className="grid size-6 pointer-coarse:size-9 shrink-0 place-items-center rounded-full text-text-tertiary transition-colors hover:bg-background hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
      >
        <X aria-hidden="true" className="size-3" />
      </button>
    </div>
  );
}
